"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _index = _interopRequireDefault(require("./../Navigation/widget-featured-topics/index.sync"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'group-featured-topics';
exports.cssAnchorName = cssAnchorName;

var GroupFeaturedTopics = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupFeaturedTopics, _Component);

  var _super = _createSuper(GroupFeaturedTopics);

  function GroupFeaturedTopics() {
    (0, _classCallCheck2.default)(this, GroupFeaturedTopics);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(GroupFeaturedTopics, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          group = _this$props.group,
          canSee = _this$props.canSee,
          allProductAreas = _this$props.allProductAreas,
          _this$props$featuredT = _this$props.featuredTopics,
          featuredTopics = _this$props$featuredT === void 0 ? [] : _this$props$featuredT;
      var curatedContent = group.category.curatedContent;
      return (0, _preact.h)("div", {
        className: "group-detail-wrapper",
        "data-bounded-context": "Groups",
        "data-entity": "group-featured-topics"
      }, canSee && (0, _preact.h)("div", {
        className: "group-featured-topics-container"
      }, (0, _preact.h)(_index.default, {
        featuredTopics: featuredTopics,
        allProductAreas: allProductAreas,
        config: {
          title: curatedContent.title,
          buttonURL: '',
          buttonLabel: '',
          subtitle: '',
          selectedDisplayViewPreference: 'card',
          backgroundColor: '',
          firstTopicsNumber: 0,
          topics: curatedContent.curatedTopics
        }
      })));
    }
  }]);
  return GroupFeaturedTopics;
}(_preact.Component);

var _default = GroupFeaturedTopics;
exports.default = _default;